import React, { useState } from 'react';
import { forNamespace } from 'app/common/lib/util/i18n';
import styles from './BoardMemberRestrictionAlert.less';
import { useBoardMemberRestrictionAlertQuery } from '@trello/graphql/generated';
import { Button } from '@trello/nachos';
import { Spinner } from 'app/src/components/Spinner';
import { useRestrictedGuests } from './useRestrictedGuests';

const format = forNamespace('workspaces preamble');

interface BoardMemberRestrictionAlertProps {
  boardId: string;
  onCancel: () => void;
  onSubmit: () => void;
  orgId: string;
}

export const BoardMemberRestrictionAlert: React.FunctionComponent<BoardMemberRestrictionAlertProps> = ({
  boardId,
  onCancel,
  onSubmit,
  orgId,
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { data, loading } = useBoardMemberRestrictionAlertQuery({
    variables: { orgId },
  });
  const {
    boardMembersNotInTeam,
    loading: restrictedGuestsLoading,
  } = useRestrictedGuests({
    orgId,
    boardId,
  });

  const onConfirm = () => {
    setIsSubmitted(true);
    onSubmit();
  };

  if (loading || restrictedGuestsLoading) {
    return <Spinner centered />;
  }

  return (
    <>
      <p className={styles.boardMemberRestrictionAlertMessaging}>
        {format(['workspaces preamble', 'board-member-restriction-messaging'], {
          orgName: (
            <strong key="orgName">{data?.organization?.displayName}</strong>
          ),
        })}
      </p>
      <p className={styles.boardMemberRestrictionAlertMembers}>
        <strong>
          {boardMembersNotInTeam.map((member) => member.fullName).join(', ')}
        </strong>
      </p>
      <Button
        appearance="danger"
        className={styles.boardMemberRestrictionAlertConfirmButton}
        isDisabled={isSubmitted}
        onClick={onConfirm}
        shouldFitContainer
      >
        {isSubmitted ? (
          <Spinner centered />
        ) : (
          format(['workspaces preamble', 'board-member-restriction-submit'])
        )}
      </Button>
      <Button
        appearance="default"
        className={styles.boardMemberRestrictionAlertCancelButton}
        isDisabled={isSubmitted}
        onClick={onCancel}
        shouldFitContainer
      >
        {format(['workspaces preamble', 'board-member-restriction-cancel'])}
      </Button>
    </>
  );
};
